import { Reminder } from '@griply/types';
import { getReminderLabel, isReminderUnresolvable } from '@griply/utils';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { BellNotifications16, Warning } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { Tooltip } from 'shared/components/ui/tooltip';
import { TimeFormatOptions } from 'shared/types/date-format-options';
import { parseDateTime } from 'shared/utils/parse-date-time';

import { MetaInteraction } from '../meta-interaction/meta-interaction';
import * as Styled from './meta-reminder.style';

export type MetaReminderRowProps = {
  reminder: Reminder;
  timeFormat: TimeFormatOptions;
  hasTime: boolean;
  showIcon?: boolean;
  onClear: (reminder: Reminder) => void;
};

export const MetaReminderRow: React.FC<MetaReminderRowProps> = ({
  reminder,
  timeFormat,
  hasTime,
  showIcon,
  onClear,
}) => {
  const { t } = useTranslation();
  const warningRef = useRef<HTMLSpanElement>(null);

  const isUnresolvable = isReminderUnresolvable(reminder, hasTime);

  const label =
    getReminderLabel(reminder, t, timeFormat) ??
    parseDateTime(reminder.offset, timeFormat);

  const _onClear = () => onClear(reminder);

  return (
    <>
      <MetaInteraction
        icon={showIcon ? BellNotifications16 : undefined}
        placeholder={label}
        label={label}
        end={
          isUnresolvable ? (
            <Styled.WarningContainer ref={warningRef}>
              <Icon icon={Warning} />
            </Styled.WarningContainer>
          ) : undefined
        }
        onClear={_onClear}
      />
      {isUnresolvable && (
        <Tooltip
          referenceElement={warningRef}
          label={t('reminders.missing-start-time')}
        />
      )}
    </>
  );
};
